var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 7,
    fill: "#091026"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 29,
    height: 2.5,
    rx: 1.25,
    fill: "url(#paint0_linear_1186_13107)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 29,
    height: 2.5,
    rx: 1.25,
    fill: "url(#paint1_linear_1186_13107)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 20,
    height: 2.5,
    rx: 1.25,
    fill: "url(#paint2_linear_1186_13107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1186_13107",
    x1: 39,
    y1: 12,
    x2: 10,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1186_13107",
    x1: 39,
    y1: 23,
    x2: 10,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1186_13107",
    x1: 30,
    y1: 34,
    x2: 10,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7D61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMobile);
export default __webpack_public_path__ + "static/media/icon_menu_mobile.e932d5a08d327bd97abe56945797aa16.svg";
export { ForwardRef as ReactComponent };